import { render, staticRenderFns } from "./EventManagement.vue?vue&type=template&id=bf9acf48&scoped=true"
import script from "./EventManagement.vue?vue&type=script&lang=js"
export * from "./EventManagement.vue?vue&type=script&lang=js"
import style0 from "./EventManagement.vue?vue&type=style&index=0&id=bf9acf48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf9acf48",
  null
  
)

export default component.exports